import React from "react";
import Joyride, { EVENTS } from "react-joyride";

import {
  useTourGuidConfigContext,
  useTourGuidConfigActionsContext,
  useTourGuidSavedSettingContext,
  useTourGuidSavedSettingActionsContext,
} from "../../Context/TourGuidContext";

import { useNavigate, useLocation } from "react-router-dom";
import { useEqDetailsTabActionContext } from "../../Context/GlobalContext";
import { useSidebarActionsContext } from "../../Context/SidebarManagementContext";
const TourGuide = ({ handleClose }) => {
  const location = useLocation();
  const guideTourstate = useTourGuidConfigContext();
  const { handleContentChange } = useSidebarActionsContext();
  const setGuideTourState = useTourGuidConfigActionsContext();
  const setTabSelected = useEqDetailsTabActionContext();
  const tourGuidSaveSetting = useTourGuidSavedSettingContext();
  const setTourGuidSaveSetting = useTourGuidSavedSettingActionsContext();
  const navigate = useNavigate();

  const handleCallback = (data) => {
    const { action, index, status, type, step, lifecycle } = data;

    if (action === "next" && type === EVENTS.STEP_BEFORE) {
      if (step && typeof step.beforeStep === "function") {
        step.beforeStep(step);
      }
    }
    if (action === "next" && type === EVENTS.STEP_AFTER) {
      setGuideTourState((prev) => ({
        ...prev,
        stepIndex: index + 1, // Save the current step index
      }));
      if (step && typeof step.delayAdded === "function") {
        step.delayAdded(step);
      } else if (typeof step.complete === "function") {
        step.complete(step);
      } else if (typeof step.afterStep === "function") {
        step.afterStep(step);
      }
    }
    if (action === "prev" && type === EVENTS.STEP_AFTER) {
      setGuideTourState((prev) => ({
        ...prev,
        stepIndex: index - 1, // Save the current step index
      }));
    }
    if (action === "next" && data.lifecycle === "complete" && data.step.data) {
      if (location.pathname !== data.step.data.next) {
        setGuideTourState((prev) => ({
          ...prev,
          run: false,
        }));
        navigate(data.step.data.next);
        handleContentChange("equipmentGrpEqiupment");
      }
    }
    if (
      action === "next" &&
      data.lifecycle === "complete" &&
      data.step.afterEquipmentDetails &&
      !data.step.lastStep
    ) {
      setGuideTourState((prev) => ({
        ...prev,
        run: false,
      }));
      setTabSelected((pre) => ({
        ...pre,
        id: data.step.afterEquipmentDetails.value,
        _key: "next",
      }));
    }
    if (
      action === "prev" &&
      data.lifecycle === "complete" &&
      data.step.afterEquipmentDetails
    ) {
      setGuideTourState((prev) => ({
        ...prev,
        run: false,
      }));
      setTabSelected((pre) => ({
        ...pre,
        id: data.step.afterEquipmentDetails.value,
        _key: "prev",
      }));
    }
    if (action === "prev") {
      if (step && typeof step.backHandle === "function") {
        step.backHandle(step);
      }
    }
    if (["skip", "close"].includes(action) || status === "finished") {
      const _temp = [...tourGuidSaveSetting];
      const List = _temp.map((item) => {
        if (
          item.title.toLowerCase() === guideTourstate.tourTitle.toLowerCase()
        ) {
          item.isTourActive = false;
        }
        return item;
      });
      if (status === "finished") {
        let tourGuideData = JSON.parse(
          sessionStorage.getItem("onBoardStoryGuid"),
        );
        tourGuideData.forEach((item) => {
          if (guideTourstate.tourId === item.id && item.isTourActive) {
            item.isTourActive = false;
          }
        });
        sessionStorage.setItem(
          "onBoardStoryGuid",
          JSON.stringify(tourGuideData),
        );
      }
      setTourGuidSaveSetting(List);
      handleClose();
    }
  };

  return (
    <Joyride
      steps={guideTourstate.steps}
      stepIndex={guideTourstate.stepIndex}
      run={guideTourstate.run}
      callback={handleCallback}
      continuous
      scrollToFirstStep
      showSkipButton={guideTourstate.stepIndex === 0}
      disableOverlayClose
      disableScrolling
      styles={{
        buttonNext: {
          backgroundColor: "#0B6BCB",
        },
      }}
    />
  );
};
export default TourGuide;

// const CustomTooltip = ({
//   index,
//   step,
//   backProps,
//   //primaryProps,
//   // skipProps,
//   closeProps,
// }) => (
//   <div className="custom-tooltip">
//     <h4>{step.title}</h4>
//     <div>{step.content}</div>
//     <FormControlLabel
//       control={
//         <Checkbox
//           // checked={dontShowTour}
//           //  onChange={handleDontShowTourChange}
//           name="dontShowTour"
//           color="primary"
//         />
//       }
//       label="Don't show tour"
//     />
//     <div className="tooltip-footer">
//       <Button>Skip</Button>
//       <Button>
//         Continue <ArrowForwardIcon />
//       </Button>
//     </div>
//   </div>
// );
